import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllClients = lazy(() => import("../pages/all-clients"));

export const ClientRouter = [
  {
    path: "/master-management/client",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllClients />
          </Suspense>
        ),
      },
    ],
  },
];
